import React, { lazy } from "react";
import Loadable from "../../components/Loadable/Loadable";
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "app/components/partials/SubscriptionDialog";
import { useSearchParams } from "react-router-dom";
import Coupons from "./Coupons/Coupons";


const Subscription= Loadable(lazy(() => import("./Subscription")));

const SubscriptionWrapper = () => {
    const [searchParams] = useSearchParams();
    const isDialog = false;
    
    return (
        <Elements stripe={stripePromise}>
            <Subscription isDialog={isDialog} />
        </Elements>
    );
};

const subscriptionRoutes = [
    {
        path: "/subscription",
       element: <SubscriptionWrapper />,
    },
    {
        path: "/subscription/dialog",
        element: (
            <Elements stripe={stripePromise}>
                <Subscription isDialog={true} />
            </Elements>
        ),
    },
    {
        path: "/subscription/config",
        element: (
            <Elements stripe={stripePromise}>
                <Subscription isDialog={false} />
            </Elements>
        ),
    },
    {
        path: "/coupon",
         element: <Coupons />,
    },
  
];

export default subscriptionRoutes;
